import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

const suburbs = [
  "Belvedere",
  "Greystone Park",
  "Highlands",
  "Strathaven",
  "Kensington",
  "Borrowdale Brooke",
  "Showgrounds",
  "Mount Pleasant",
  "Unknown",
  "CBD",
  "Helensvale",
  "Borrowdale",
  "Langhorn Lane",
  "Avenues",
  "Vainona",
];

const speeds = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 15, 20, 21, 50];

const SuburbSpeedWidget = () => {
  return (
    <Card sx={{ height: "100%", width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Suburb Speed Rank
        </Typography>

        <BarChart
          layout="horizontal"
          height={400}
          series={[
            {
              data: speeds,
              label: "Upload Speed (Mbps)",
              color: "#6366F1",
            },
          ]}
          yAxis={[
            {
              scaleType: "band",
              data: suburbs,
            },
          ]}
          xAxis={[
            {
              label: "internet_upload_speed",
            },
          ]}
        />
      </CardContent>
    </Card>
  );
};

export default SuburbSpeedWidget;
